<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row>
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <el-table-column label="图片" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.img" style="width:120px;height:120px">
        </template>
      </el-table-column>
      <el-table-column label="跳转模块" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.link_type == 1">商品详情</el-tag>
          <el-tag type="danger" v-if="scope.row.link_type == 2">直播间</el-tag>
          <el-tag type="primary" v-if="scope.row.link_type == 3">外链</el-tag>
          <!-- <el-tag type="info" v-if="scope.row.link_type == 4">公告</el-tag> -->
          <el-tag type="info" v-if="scope.row.link_type == 5">领券中心</el-tag>
          <el-tag type="warning" v-if="scope.row.link_type == 6">不跳转</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="跳转模块 值" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.link_type == 1">{{scope.row.link}}</el-tag>
          <el-tag type="danger" v-if="scope.row.link_type == 2">{{scope.row.link}}</el-tag>
          <span v-if="scope.row.link_type == 3">{{scope.row.link}}</span>
          <!-- <span v-if="scope.row.link_type == 4">公告内容编辑处查看</span> -->
          <el-tag type="warning" v-if="scope.row.link_type == 5">领券中心</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="权重" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center"  class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="130px">
        <el-form-item label="图片(750x500)" prop="img">
          <UploadOne v-model="form.img"></UploadOne>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input type="number" v-model="form.weight" clearable/>
        </el-form-item>
        <el-form-item label="跳转模块" prop="link_type">
          <el-select
            v-model="form.link_type"
            placeholder="商品详情"
           
          >
            <el-option v-for="item in jumpList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品详情" prop="link" v-if="form.link_type == 1">
          <el-input type="number" v-model="form.link" placeholder="请输入商品id" clearable/>
        </el-form-item>
        <el-form-item label="直播间" prop="link" v-if="form.link_type == 2">
          <el-input type="number" v-model="form.link" placeholder="请输入直播间id" clearable/>
        </el-form-item>
        <el-form-item label="外链" prop="link" v-if="form.link_type == 3">
          <el-input type="text" v-model="form.link" placeholder="必须https且在小程序后台添加安全域名" clearable/>
        </el-form-item>
        <!-- <el-form-item label="公告:" prop="link" v-if="form.link_type == 4">
          <Tinymce v-model="form.link"></Tinymce>
        </el-form-item> -->
        <el-form-item label="领券中心" prop="link" v-if="form.link_type == 5">
          <span>不需要填写</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import request from '@/utils/request'
import Tinymce from "@/components/Tinymce";
import UploadOne from "@/components/UploadOne";
import 'babel-polyfill'; // es6 shim

export default {
  components: {
    Tinymce,
    UploadOne,
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      jumpList:[
        {id:1,name:'商品详情'},
        {id:2,name:'直播间'},
        {id:3,name:'外链'},
        // {id:4,name:'公告'},
        {id:5,name:'领券中心'},
        {id:6,name:'不跳转'},
      ],
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: '',
        img:'',
        weight: 1,
        link_type:6,
        link:'',
      },
      rules: {
        img: [{ required: true, message: '图片不能为空', trigger: 'blur' }],
        // weight: [{ min: 0, message: '权重不能小于0', trigger: 'blur' }],
        // link: [{ required: true, message: '请根据当前跳转模块输入对应的值', trigger: 'blur' }],
      },
      btnLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/banner',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: '',
        img: '',
        weight: 1,
        link_type:6,
        link:'',
      }
      this.btnLoading = false
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.form = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      if(this.form.link_type == 5 || this.form.link_type == 6) {
        this.form.link = 66666
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/banner/save',
            method: 'post',
            data: this.form
          }).then(response => {
            this.btnLoading = false
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              duration: 2000
            })
            this.getList();
          }).catch((err) => {
            this.btnLoading = false
          })
        }else{
          return false
        }
      })
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/banner/del',
          method: 'get',
          params: {id: val}
        }).then(()=>{
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  }
}
</script>


<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover{
  border-color: #409EFF;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
